import DOMPurify from 'dompurify';

/**
 * Утилита для безопасной очистки HTML перед вставкой через dangerouslySetInnerHTML
 * Использует DOMPurify для защиты от XSS атак
 */

/**
 * Санитизирует HTML контент для безопасной вставки
 * @param {string} dirty - Грязный HTML контент
 * @param {Object} config - Дополнительные настройки DOMPurify
 * @returns {string} - Очищенный HTML
 */
export const sanitizeHtml = (dirty, config = {}) => {
  if (!dirty || typeof dirty !== 'string') {
    return '';
  }

  // Базовая конфигурация DOMPurify для разрешения основных тегов форматирования
  const defaultConfig = {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'u', 'br', 'p', 'span', 'div', 'a', 'ul', 'ol', 'li'],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
    ALLOW_DATA_ATTR: false
  };

  const finalConfig = { ...defaultConfig, ...config };

  return DOMPurify.sanitize(dirty, finalConfig);
};

/**
 * Санитизирует HTML для markdown контента (после парсинга markdown)
 * @param {string} dirty - HTML после парсинга markdown
 * @returns {string} - Очищенный HTML
 */
export const sanitizeMarkdownHtml = (dirty) => {
  return sanitizeHtml(dirty, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'u', 'del', 'br', 'p', 'span', 'div', 'a', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class']
  });
};
